import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface SupportTripDestinationState {
  supportTripDestination: Parameter[];
  setSupportTripDestination: (newSupportTripDestination: Parameter[] | undefined) => void;
}

export const useSupportTripDestinationStore = create<SupportTripDestinationState>()(
  devtools(
    (set) => ({
      supportTripDestination: [],
      setSupportTripDestination: (newSupportTripDestination) =>
        set(() => ({
          supportTripDestination: newSupportTripDestination ? [...newSupportTripDestination] : [],
        })),
    }),
    { name: "SupportTripDestinationStore" }
  )
);
